import {
  GET_SURVEY_EVENTS,
  FETCH_SURVEY_EVENT,
  ADD_SURVEY_EVENT,
  UPDATE_SURVEY_EVENT,
  DELETE_SURVEY_EVENT,
  CLEAR_SURVEY_EVENTS,
  SURVEY_EVENTS_PAGE,
  CLEAR_ALL,
  SURVEY_EVENTS_PENDING, // Added pending action type
} from "../constants/actions";

const initialState = {
  survey_events: [],
  pending: false,
  pageNumber: 1,
  created: false,
  updated: false,
};

export default function surveyEvents(state = initialState, action) {
  switch (action.type) {
    case SURVEY_EVENTS_PENDING: // Added pending case
      return {
        ...state,
        pending: true,
      };
    case GET_SURVEY_EVENTS:
      return {
        ...state,
        survey_events: action.payload,
        pending: false,
      };
    case SURVEY_EVENTS_PAGE:
      return {
        ...state,
        pageNumber: action.payload,
      };
    case FETCH_SURVEY_EVENT:
      return {
        ...state,
        [action.payload.id]: action.payload,
        pending: false,
      };
    case ADD_SURVEY_EVENT:
      return {
        ...state,
        created: action.payload,
        pending: false,
      };
    case UPDATE_SURVEY_EVENT:
      return {
        ...state,
        [action.payload.id]: action.payload,
        pending: false,
      };
    case DELETE_SURVEY_EVENT:
      return {
        ...state,
        updated: Math.random(),
        pending: false,
      };
    case CLEAR_SURVEY_EVENTS:
      return {
        ...state,
        ...initialState,
      };
    case CLEAR_ALL:
      return initialState;
    default:
      return state;
  }
}